import React, { useContext } from 'react';
import { apiContext, clearAuthSession } from '../../Api';
import { keycloakConfig } from '../../keycloak';

function Logout() {
    const { axios } = useContext(apiContext);
    React.useEffect(() => {
        const logout = async () => {
            const keycloakIdToken = localStorage.getItem('keycloak_id_token');

            try {
                await axios.post('/logout');
            } catch (error) {
                // ignore, local logout should continue
            }

            clearAuthSession();

            if (keycloakConfig.hasKeycloakConfig) {
                const params = new URLSearchParams({
                    redirect_uri: keycloakConfig.logoutRedirectUri,
                    client_id: keycloakConfig.clientId,
                });

                if (keycloakIdToken) {
                    params.set('id_token_hint', keycloakIdToken);
                }

                window.location.assign(`${keycloakConfig.logoutEndpoint}?${params.toString()}`);
                return;
            }

            window.open('/', "_self");
        };

        logout();
    }, [axios])

    return null;
}
export default Logout;
